import { images } from "../assets/Images/assetsImages";
import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/CategoryPageComponents/HeroSection";
import ProductsSection from "../components/CategoryPageComponents/ProductsSection";
import CustomerFavSection from "../components/CategoryPageComponents/CustomerFavSection";

export default function ViennoiseriePage() {

    const heroData = [
        {
          title: "Viennoiserie",
          content: "Viennoiserie refers to a variety of French pastries, made from rich, buttery dough, similar to puff pastry. Common examples include croissants, pain au chocolat, and brioche, known for their flaky texture and sweet, indulgent flavor.",
          image: images.ViennoiserieHeroImage, 
        },
      ];

    const productData = [
      {
        name: "Butter Croissant",
        content: "Classic, flaky, buttery croissant",
        price: 0,
        image: [
          images.Viennoiserie1,
        ]
      },
      {
        name: "Chocolate Croissant",
        content: "Buttery croissant filled with rich chocolate",
        price: 0,
        image: [
          images.Viennoiserie2,
        ]
      },
      {
        name: "Almond Croissant",
        content: "Filled with almond paste and topped with slivered almonds",
        price: 0,
        image: [
          images.Viennoiserie3,
        ]
      },
      {
        name: "Pistachio Croissant",
        content: "Pistachio filling with a nutty topping",
        price: 0,
        image: [
          images.Viennoiserie1,
        ]
      },
      {
        name: "Zaatar Croissant",
        content: "A savory croissant with zaatar seasoning",
        price: 0,
        image: [
          images.Viennoiserie2,
        ]
      },
    ]

    const customerFavData = [
      {
        name1: "Chocolate Croissant",
        image1: [
          images.Viennoiserie2,
        ],
        content1: "Buttery croissant filled with rich chocolate",
        name2: "Almond Croissant",
        image2: [
          images.Viennoiserie3,
        ],
        content2: "Filled with almond paste and topped with slivered almonds"
      },
    ]

    return (
      <div className="relative w-full min-h-screen bg-[#C3D7A4] bg-opacity-60">
        <MainLayout>
            <HeroSection heroData={heroData} />
            <ProductsSection productData={productData} />
            <CustomerFavSection customerFavData={customerFavData} />
        </MainLayout>
      </div>
    );
  }
  
